import { render, staticRenderFns } from "./HelloWorld.vue?vue&type=template&id=4b994f0c"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports